import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  folderService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'folderModel',
    function (runtimeConstant, $http, $q, $filter, webApiSettings, Folder) {
      'use strict';

      var folderServiceFactory = {};
      var loadDeferred = null;

      function handleError(err, isDelete, isLoadFolder) {
        if (err.status === 404 || err.status === -1) {
          return {
            statusCode: err.status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }

        if (err.data.Documents !== undefined && err.data.Documents.length > 0) {
          return {
            statusCode: err.status,
            title: $filter('translate')('ERROR'),
            text: err.data.Documents,
          };
        }

        if (err.data.Acronym !== undefined && err.data.Acronym.length > 0) {
          return {
            statusCode: err.status,
            title: $filter('translate')('ERROR'),
            text: err.data.Acronym,
          };
        }

        if (err.data.ModelState) {
          if (err.data.ModelState.Documents) {
            return {
              title: $filter('translate')('ERROR'),
              text: err.data.ModelState.Documents[0],
            };
          }
          if (err.data.ModelState.Acronym) {
            return {
              title: $filter('translate')('ERROR'),
              text: err.data.ModelState.Acronym[0],
              modelState: {
                Acronym: err.data.ModelState.Acronym,
              },
            };
          }
          return {
            title: $filter('translate')('ERROR'),
            text: $filter('translate')('AN ERROR OCCURRED'),
          };
        }

        return {
          statusCode: err.status,
          title: $filter('translate')('ERROR'),
          text: $filter('translate')(
            isLoadFolder
              ? 'ERROR LOAD FOLDER'
              : isDelete
                ? 'ERROR DELETE FOLDER'
                : 'ERROR SAVE FOLDER'
          ),
        };
      }

      function loadFolder(idFolder) {
        var deferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              'folders/getWithParent/' +
              idFolder,
            {
              ignoreLoadingBar: true,
            }
          )
          .then(
            function (result) {
              var data = result.data;
              var folder = new Folder(data);

              deferred.resolve(folder);
            },
            function (err, status, headers, config) {
              var error = handleError(
                {
                  err: err,
                  status: status,
                  headers: headers,
                  config: config,
                  data: {},
                },
                false,
                true
              );
              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function cancelLoad() {
        if (loadDeferred !== null) {
          loadDeferred.resolve({
            data: null,
          });

          loadDeferred = null;
        }
      }

      function load(idFolder, isCheckin) {
        loadDeferred = $q.defer();

        var now = new Date();

        var hourMilisecs = 1000 * 60 * 60;

        if (
          folderServiceFactory.folders[idFolder] !== null &&
          folderServiceFactory.folders[idFolder] !== undefined &&
          folderServiceFactory.folders[idFolder].date.getTime() >
            now.getTime() - hourMilisecs
        ) {
          loadDeferred.resolve(folderServiceFactory.folders[idFolder].folder);
        }

        var urlController = isCheckin
          ? 'folders/getFolderFromShared/'
          : 'folders/';

        $http
          .get(webApiSettings.apiServiceBaseUri + urlController + idFolder, {
            ignoreLoadingBar: true,
            timeout: loadDeferred.promise,
          })
          .then(
            function (result) {
              var data = result.data;
              folderServiceFactory.folders[idFolder] = {
                date: now,
                folder: data,
              };

              if (loadDeferred !== null) {
                loadDeferred.resolve(data);
                loadDeferred = null;
              }
            },
            function (err, status) {
              handleError;
              loadDeferred.reject({
                error: err,
                status: status,
              });
            }
          );

        return loadDeferred.promise;
      }

      function recursiveCreateTree(items, parent, idsToSelect) {
        //Verifica se existem algum item que seja filho do 'parent'
        if (
          parent !== null &&
          parent !== undefined &&
          items.some(function (c) {
            return c.idParent === parent.id;
          })
        ) {
          parent.children = [];

          for (var i = 0, len = items.length; i < len; i++) {
            var c = items[i];

            // Define se é folder ou repositorio
            c.treeItemType = c.idParent === null ? 0 : 1;

            if (idsToSelect && idsToSelect.indexOf(c.id) > -1) {
              c._selected = true;
            }

            // Insere os filhos
            if (c.idParent === parent.id) {
              // remove da lista de itens
              var childs = items.splice(i, 1);
              len--;
              i--;
              parent.children.push(childs[0]);
            }
          }
        } else {
          return;
        }

        //Chama o create tree para cada um dos filhos
        for (var j = 0, length = parent.children.length; j < length; j++) {
          recursiveCreateTree(items, parent.children[j], idsToSelect);
        }
      }

      function loadBasic(idsToSelect) {
        var deferred = $q.defer();
        $http
          .get(webApiSettings.apiServiceBaseUri + 'folders/basic', {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              var data = result.data;
              var folders = [];
              data = resolveReferences(data);
              for (var i = 0; i < data.length; i++) {
                folders.push(new Folder(data[i]));
              }

              var repositories = folders.filter(function (f) {
                return f.idParent === undefined || f.idParent === null;
              });

              for (i = 0; i < repositories.length; i++) {
                if (
                  idsToSelect &&
                  idsToSelect.indexOf(repositories[i].id) > -1
                ) {
                  repositories[i]._selected = true;
                }
                var parent = repositories[i];

                recursiveCreateTree(folders, parent, idsToSelect);
              }

              deferred.resolve(repositories);
            },
            function (err) {
              deferred.reject({
                error: err.data,
                status: err.status,
              });
            }
          );

        return deferred.promise;
      }

      function saveKeepingPermissions(folder) {
        var deferred = $q.defer();

        folder.idParent = folder.parent.id;

        $http
          .put(
            webApiSettings.apiServiceBaseUri +
              'folders/keepPermissions?keepPermissions=true',
            folder,
            {
              ignoreLoadingBar: true,
            }
          )
          .then(
            function () {
              deferred.resolve(folder);
            },
            function (err, status, header, config) {
              deferred.reject(handleError(err, status, header, config));
            }
          );

        return deferred.promise;
      }

      function save(folder, workflow) {
        var deferred = $q.defer();

        if (folder.id === 0) {
          folder.path = null;
          $http
            .post(
              webApiSettings.apiServiceBaseUri + 'folders?workflow=' + workflow,
              folder,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(
              function (result) {
                deferred.resolve(new Folder(result.data));
              },
              function (err, status, header, config) {
                deferred.reject(handleError(err, status, header, config));
              }
            );
        } else {
          $http
            .put(
              webApiSettings.apiServiceBaseUri + 'folders?workflow=' + workflow,
              folder,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(
              function () {
                deferred.resolve(folder);
              },
              function (err, status, header, config) {
                deferred.reject(handleError(err, status, header, config));
              }
            );
        }

        return deferred.promise;
      }

      function _delete(folder, deleteTrashCan) {
        var deferred = $q.defer();

        var url =
          'folders/' +
          folder.Id +
          '?deleteFilesTrashCan=' +
          (deleteTrashCan ? 'true' : 'false');

        $http.delete(webApiSettings.apiServiceBaseUri + url).then(
          function () {
            deferred.resolve(true);
          },
          function (err) {
            deferred.reject(handleError(err, true));
          }
        );

        return deferred.promise;
      }

      function shared(folderId, publicLinkDate) {
        var deferred = $q.defer();

        var data = {
          folderId: folderId,
          publicLinkDate: publicLinkDate || null,
        };

        $http
          .post(webApiSettings.apiServiceBaseUri + 'folders/shared', data, {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              deferred.resolve(result.data);
            },
            function (err, status, header, config) {
              deferred.reject(handleError(err, status, header, config));
            }
          );

        return deferred.promise;
      }

      function deleteShared(folderId) {
        var deferred = $q.defer();

        var url = 'folders/shared/' + folderId;

        $http.delete(webApiSettings.apiServiceBaseUri + url).then(
          function () {
            deferred.resolve(true);
          },
          function (err) {
            deferred.reject(handleError(err, true));
          }
        );

        return deferred.promise;
      }

      function run() {
        try {
          folderServiceFactory.folders = [];

          folderServiceFactory.load = logWrapper(
            load,
            runtimeConstant.isDebugServicesInternals
          );
          folderServiceFactory.loadBasic = logWrapper(
            loadBasic,
            runtimeConstant.isDebugServicesInternals
          );
          folderServiceFactory.cancelLoad = logWrapper(
            cancelLoad,
            runtimeConstant.isDebugServicesInternals
          );
          folderServiceFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          folderServiceFactory.saveKeepingPermissions = logWrapper(
            saveKeepingPermissions,
            runtimeConstant.isDebugServicesInternals
          );
          folderServiceFactory.delete = logWrapper(
            _delete,
            runtimeConstant.isDebugServicesInternals
          );
          folderServiceFactory.loadFolder = logWrapper(
            loadFolder,
            runtimeConstant.isDebugServicesInternals
          );
          folderServiceFactory.shared = logWrapper(
            shared,
            runtimeConstant.isDebugServicesInternals
          );
          folderServiceFactory.deleteShared = logWrapper(
            deleteShared,
            runtimeConstant.isDebugServicesInternals
          );

          return folderServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
